import React from 'react';

export const ClockIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="12.0002"
      cy="12.0828"
      r="8.91724"
      stroke="#27B0E0"
      strokeWidth="2"
    />
    <path
      d="M11.8115 6.50708V12.2522H15.7693"
      stroke="#27B0E0"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
